import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-prioritize-user',
  standalone: false,
  templateUrl: './prioritize-user.component.html',
  styleUrl: './prioritize-user.component.scss'
})
export class PrioritizeUserComponent {
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<PrioritizeUserComponent>);

  selectedPersona: any;

  selectPersona(selection: any) {
    this.selectedPersona = selection;
  }

  back() {
    this.dialogRef.close();
  }
  saveSelectedPersona() {
    this.dialogRef.close(this.selectedPersona);
  }
}
